(function() {
	'use strict';

	angular
		.module('procedureControllers')
		.controller('ProcedureResponsibilityEditController', Controller);

	Controller.$inject = ['$scope',
						  'topBarService',
						  'responsibility'];

	function Controller($scope,
						topBarService,
						responsibility) {

		topBarService.setTitleAndIcon('Edit Responsibility', 'fa fa-book');

		$scope.responsibility = responsibility;
	}
})();